// extracted by mini-css-extract-plugin
export default {"label":"info-label_label__ELYE9","content":"info-label_content__uHh7O"};